---
title: Terms
updated: 2026-10-02
---

## 1. Acceptance of Terms

By creating an account or using Draughts Game ("the Service"), you agree to be bound by these Terms of Service. If you do not agree, please do not use the Service.

## 2. Description of Service

Draughts Game is an online platform for playing draughts in multiple variants. The Service includes matchmaking against other players or the computer, tournaments, player ratings, tactics puzzles, and game analysis features.

## 3. Account Registration

To access certain features, you must create an account by providing a username, email address, and password. You must verify your email address before you can sign in. You are responsible for maintaining the confidentiality of your account credentials. You may also play as a guest without registration, with limited functionality.

- You must be at least 16 years old to create an account.
- You may only create one account per person.
- You are responsible for all activity that occurs under your account.

## 4. User Conduct

When using the Service, you agree not to:

- Use external assistance (engines, solvers) during rated games.
- Intentionally lose games to manipulate ratings (sandbagging).
- Collude with other players in tournaments.
- Harass, threaten, or abuse other users.
- Create multiple accounts to circumvent bans or manipulate rankings.
- Attempt to exploit bugs or vulnerabilities in the platform.
- Use automated tools (bots) to play games without authorization.

## 5. Fair Play

We reserve the right to use automated systems to detect cheating and unfair play. Violations may result in warnings, temporary suspensions, rating adjustments, or permanent bans at our discretion.

## 6. Intellectual Property

The Service, including its design, original code, graphics, and content, is owned by Draughts Game. Game records (moves, results) are public data and may be freely shared. User-generated content (usernames, chat messages) remains the property of their respective authors.

## 7. Availability and Modifications

We strive to keep the Service available at all times, but we do not guarantee uninterrupted access. We reserve the right to modify, suspend, or discontinue any part of the Service at any time. We may update these Terms from time to time. Continued use of the Service after changes constitutes acceptance.

## 8. Limitation of Liability

The Service is provided "as is" without warranties of any kind, express or implied. We are not liable for any indirect, incidental, or consequential damages arising from your use of the Service. Our total liability shall not exceed the amount you have paid to us in the 12 months preceding the claim (if any).

## 9. Termination

You may delete your account at any time from your profile settings ("Delete account"), or by contacting us. We may terminate or suspend your account if you violate these Terms or engage in conduct harmful to the Service or other users.

## 10. Contact

For questions about these Terms, please contact us at: [legal@draughtsgame.com](mailto:legal@draughtsgame.com)
